import { jsx } from "react/jsx-runtime";
import { cn } from "../../../utils/cn.js";
function PageTransitionOverlay({ animationClassName = "animate-fade-out", className }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "pointer-events-none fixed right-0 top-0 h-screen w-screen bg-darkBrand-700 bg-opacity-25 lg:hidden",
        animationClassName,
        className
      )
    }
  );
}
export {
  PageTransitionOverlay as default
};
